export default __webpack_public_path__ + "static/media/skill_dev.3a497683.jpg";